import type { AuthService } from "./authService";
import type { User } from "./authService";
import { normalizePlatformRoleNames } from "../utils/roles";

type AuthContextLookup = Pick<AuthService, "getUserContext">;

/**
 * Merge Cognito identity with platform user context (GET /platform/user-context).
 * Throws when platform context cannot be loaded — callers must not proceed with Cognito-only roles.
 */
export async function hydratePlatformUser(
  authService: AuthContextLookup,
  cognitoUser: User,
): Promise<User> {
  const context = await authService.getUserContext();
  const roles = normalizePlatformRoleNames(context.roles);

  return {
    ...cognitoUser,
    id: context.userId > 0 ? context.userId : cognitoUser.id,
    name: context.name || cognitoUser.name,
    email: context.email || cognitoUser.email,
    status: context.status,
    roles,
    role: roles[0],
    permissions: context.permissions,
    skills: context.skills,
  };
}
